import { Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const elements = {
	container: styled.div`
		width: 100%;
		padding: ${tokens.spacing.x3} ${tokens.spacing.x2};
		color: ${tokens.color.content.muted};
		border: 1px dashed ${tokens.color.border.default};
		border-radius: 12px;
		text-align: center;
	`,
};

export function EmptyState(props: PropsWithChildren): JSX.Element {
	return (
		<elements.container>
			<Text variant='labelRegular'>{props.children}</Text>
		</elements.container>
	);
}
